import { adminFetch } from "./_client";
import type { BookingImportBatch, BookingImportRow, BookingImportPreviewResponse } from "./types";


export function previewBookingImportCsv(token: string, csvContent: string) {
  return adminFetch<BookingImportPreviewResponse>("/admin/booking-imports/preview", token, {
    method: "POST",
    body: JSON.stringify({ csvContent }),
  });
}


export function uploadBookingImportCsv(token: string, csvContent: string, filename: string, notes?: string) {
  return adminFetch<{
    batch: BookingImportBatch;
    alreadyStaged: boolean;
    // Present only when alreadyStaged: how many rows in the existing batch are
    // stuck (errored/rejected) but have all three matches and so can be retried.
    retryableRows?: number;
    warnings?: { row: number; message: string }[];
  }>(
    "/admin/booking-imports",
    token,
    { method: "POST", body: JSON.stringify({ csvContent, filename, notes }) },
  );
}


export function fetchBookingImportBatches(token: string) {
  return adminFetch<{ batches: BookingImportBatch[] }>("/admin/booking-imports", token);
}


export function fetchBookingImportBatch(token: string, batchId: number) {
  return adminFetch<{ batch: BookingImportBatch; rows: BookingImportRow[] }>(
    `/admin/booking-imports/${batchId}`, token,
  );
}


export function updateBookingImportRow(
  token: string,
  rowId: number,
  patch: { matchedRenterId?: number | null; matchedOwnerId?: number | null; matchedCarId?: number | null; matchNotes?: string | null },
) {
  return adminFetch<{ row: BookingImportRow }>(`/admin/booking-imports/rows/${rowId}`, token, {
    method: "PATCH",
    body: JSON.stringify(patch),
  });
}


export function approveBookingImport(token: string, batchId: number, rowIds?: number[]) {
  return adminFetch<{
    outcomes: Array<{ rowId: number; legacyId: string; status: "approved" | "errored"; tripId?: number; error?: string }>;
    counts: { approved: number; ready: number; pending: number; errored: number; rejected: number };
    batchStatus: string;
  }>(`/admin/booking-imports/${batchId}/approve`, token, {
    method: "POST",
    body: JSON.stringify(rowIds && rowIds.length > 0 ? { rowIds } : {}),
  });
}


export function rejectBookingImportRow(token: string, rowId: number, reason?: string) {
  return adminFetch<{ row: BookingImportRow }>(`/admin/booking-imports/rows/${rowId}/reject`, token, {
    method: "POST",
    body: JSON.stringify({ reason }),
  });
}


export function retryBookingImportRow(token: string, rowId: number) {
  return adminFetch<{ row: BookingImportRow }>(`/admin/booking-imports/rows/${rowId}/retry`, token, {
    method: "POST",
    body: JSON.stringify({}),
  });
}
